import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { useShallow } from 'zustand/react/shallow';

import { createHeaderSlice, createRadioSlice } from 'app/slices';

export const _useBoundStore = create(
  immer((set, get) => ({ ...createHeaderSlice(set, get), ...createRadioSlice(set, get) })),
);

export function useBoundStore(selector) {
  if (!selector) {
    selector = () => undefined;
  }

  return _useBoundStore(useShallow(selector));
}
